import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';

export default Vue.extend({
    computed: {
        ...mapGetters({
            sessionExists: 'apiSession/exists',
            sessionUserId: 'apiSession/userId',
            sessionId: 'apiSession/sessionId',
            sessionName: 'apiSession/sessionName',
            jidNode: 'apiSession/jidNode'

        }),
    },
    methods: {
        ...mapActions({
            login: 'apiSession/login',
            restore: 'apiSession/restoreXMPP',
            logout: 'apiSession/logout',
        }),
    },
});
